import React from "react";
import styles from "./RythmeFond.module.css";
import {PALETTES, REGLAGES} from "./reglages";
import {graine} from "../arcade/sprites";
import {resoudre} from "../reglages";

/**
 * Fonds du thème Rythme : trois ambiances de jeu de musique rythmique, en CSS pur (dessins et code originaux, aucun personnage
 * ni élément d'un jeu existant). Un seul composant, trois variantes (`variante`) :
 *   pistes    : des notes colorées tombent le long de pistes vers une ligne de frappe qui s'illumine ;
 *   egaliseur : barres d'égaliseur qui montent et descendent en cadence ;
 *   scene     : faisceaux de projecteurs qui balaient, étincelles et notes de musique qui montent.
 * Tout bouge par `transform` ou `opacity` ; les positions sont tirées une fois avec une graine fixe.
 */
const PISTES = 8;

function Pistes({nombre, palette}) {
    const hasard = graine(101);
    return (
        <>
            {Array.from({length: PISTES}, (_, i) => <div key={i} className={styles.piste} style={{left: `${i * (100 / PISTES)}%`}}/>)}
            {Array.from({length: nombre * 2}, (_, i) => {
                const piste = Math.floor(hasard() * PISTES);
                const couleur = palette.vives[piste % palette.vives.length];
                return (
                    <div key={i} className={styles.noteBloc} style={{left: `${piste * (100 / PISTES)}%`, animationDelay: `${-hasard() * 12}s`, animationDuration: `${4 + hasard() * 2}s`}}>
                        <div className={styles.note} style={{background: couleur, boxShadow: `0 0 10px ${couleur}`}}/>
                    </div>
                );
            })}
            <div className={styles.frappe} style={{"--couleur": palette.vives[0]}}/>
        </>
    );
}

function Egaliseur({nombre, palette}) {
    const hasard = graine(113);
    const barres = Math.min(nombre * 3, 72);
    return (
        <div className={styles.barres}>
            {Array.from({length: barres}, (_, i) => (
                <div key={i} className={styles.barre} style={{
                    background: `linear-gradient(0deg, ${palette.vives[i % palette.vives.length]}, ${palette.vives[(i + 1) % palette.vives.length]})`,
                    animationDelay: `${-hasard() * 3}s`, animationDuration: `${0.6 + hasard() * 1.2}s`}}/>
            ))}
        </div>
    );
}

const NOTES = ["♪", "♫", "♩", "♬"];

function Scene({nombre, palette}) {
    const hasard = graine(127);
    return (
        <>
            {Array.from({length: Math.min(nombre, 12)}, (_, i) => (
                <div key={i} className={styles.faisceau} style={{left: `${(i + 0.5) * (100 / Math.min(nombre, 12))}%`, "--lumiere": palette.vives[i % palette.vives.length],
                    animationDelay: `${-hasard() * 8}s`, animationDuration: `${5 + hasard() * 4}s`}}/>
            ))}
            {Array.from({length: nombre * 2}, (_, i) => (
                <span key={i} className={styles.musique} style={{left: `${hasard() * 96}%`, color: palette.vives[i % palette.vives.length],
                    animationDelay: `${-hasard() * 14}s`, animationDuration: `${9 + hasard() * 7}s`}}>{NOTES[i % NOTES.length]}</span>
            ))}
        </>
    );
}

const VARIANTES = {pistes: Pistes, egaliseur: Egaliseur, scene: Scene};

export default function RythmeFond({variante = "pistes", reglages}) {
    const r = resoudre(REGLAGES, reglages);
    const palette = PALETTES[r.palette] || PALETTES.pop;
    const Variante = VARIANTES[variante] || Pistes;
    return (
        <div className={styles.scene} aria-hidden="true"
             style={{background: `linear-gradient(180deg, ${palette.haut}, ${palette.bas})`, "--vitesse": 1 / r.vitesse}}>
            <Variante nombre={r.nombre} palette={palette}/>
        </div>
    );
}

export const fondRythme = variante => function FondRythme(props) {
    return <RythmeFond variante={variante} {...props}/>;
};
